import EventHandler from './EventHandler';
import FeaturedCollection from './FeaturedCollection';
import cjs from './helpers/cjs';
import { transition } from './helpers/common';
export default class StaticSubcollectionsFeaturedCollection {
    constructor(section) {
        this.context = section.data.context;
        const collectionEls = section.el.querySelectorAll('[data-featured-collection]');
        this.collections = Array.prototype.map.call(collectionEls, (collectionEl) => new FeaturedCollection({
            el: collectionEl,
            sectionId: section.id,
        }));
        this.menuWrapper = section.el.querySelector('[data-subcollection-menu-wrapper]');
        this.menuToggle = section.el.querySelector('[data-subcollection-menu-toggle-more]');
        if (this.menuWrapper && this.menuToggle) {
            this.events = new EventHandler();
            this.menuIsOpen = false;
            this.menuTransition = transition({
                el: this.menuWrapper,
                state: 'closed',
                stateAttribute: 'data-subcollections-menu-state',
                stateChangeAttribute: 'data-subcollections-menu-animation',
            });
            this.events.register(this.menuToggle, 'click', () => {
                if (this.menuIsOpen) {
                    this._closeMenu();
                }
                else {
                    this._openMenu();
                }
            });
            this.onBreakpointChange = () => this._closeMenu();
            cjs.onChange(this.onBreakpointChange);
        }
    }
    onSectionUnload() {
        this.collections.forEach((collection) => collection.unload());
        if (this.events)
            this.events.unregisterAll();
        cjs.offChange(this.onBreakpointChange);
    }
    _openMenu() {
        this.menuIsOpen = true;
        this.menuToggle.innerHTML = this.context.see_less;
        const { height: closedHeight } = this.menuWrapper.getBoundingClientRect();
        this.menuWrapper.style.setProperty('--menu-closed-height', `${closedHeight}px`);
        this.menuWrapper.style.maxHeight = 'none';
        this.menuTransition.animateTo('open', {
            onStart: () => {
                const { height: menuToggleHeight } = this.menuToggle.getBoundingClientRect();
                const openHeight = this.menuWrapper.scrollHeight + menuToggleHeight;
                this.menuWrapper.style.setProperty('--menu-open-height', `${openHeight}px`);
            },
        });
    }
    _closeMenu() {
        this.menuIsOpen = false;
        this.menuToggle.innerHTML = this.context.see_more;
        this.menuTransition.animateTo('closed').then(() => {
            this.menuWrapper.style.removeProperty('--menu-closed-height');
            this.menuWrapper.style.maxHeight = null;
        });
    }
}
